import { render, staticRenderFns } from "./ProductGalleryImage.vue?vue&type=template&id=5509494d&scoped=true&"
import script from "./ProductGalleryImage.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryImage.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryImage.vue?vue&type=style&index=0&id=5509494d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509494d",
  null
  
)

export default component.exports